import apiService from './api';

export interface TransportPackagePayload { length_mm?: number; width_mm?: number; height_mm?: number; weight_kg?: number }
export interface CreateTransportPayload {
  reference?: string;
  readiness_date?: string;
  delivery_address?: string;
  client_name?: string;
  client_email?: string;
  producer_logistics_email?: string;
  producer_finance_email?: string;
  notes?: string;
  order_ids?: number[];
  carrier_ids?: number[];
  packages?: TransportPackagePayload[];
}

export interface Forwarder {
  name: string;
  email?: string;
  phone?: string;
}

export interface Driver {
  name: string;
  email?: string;
  phone?: string;
}

export interface Carrier {
  id: number;
  name: string;
  email?: string;
  phone?: string;
  nip?: string;
  forwarders?: Forwarder[];
  drivers?: Driver[];
  is_active: boolean;
}

class TransportService {
  private baseUrl = '/transport';

  async listCarriers(all: boolean = false) {
    const resp = await apiService.get(`${this.baseUrl}/carriers/list${all ? '?all=true' : ''}`);
    return resp.data as Array<{ id: number; name: string; email?: string; phone?: string; is_active: boolean }>;
  }

  async getCarrier(id: number): Promise<Carrier> {
    const resp = await apiService.get(`${this.baseUrl}/carriers/${id}`);
    return resp.data as Carrier;
  }

  async createCarrier(payload: { name: string; email?: string; phone?: string }) {
    const resp = await apiService.post(`${this.baseUrl}/carriers`, payload);
    return resp.data;
  }

  async updateCarrier(id: number, payload: { name?: string; email?: string; phone?: string; nip?: string; forwarders?: Forwarder[]; drivers?: Driver[]; is_active?: boolean }) {
    const resp = await apiService.put(`${this.baseUrl}/carriers/${id}`, payload);
    return resp.data;
  }

  async deleteCarrier(id: number) {
    const resp = await apiService.delete(`${this.baseUrl}/carriers/${id}`);
    return resp.data;
  }

  async create(payload: CreateTransportPayload) {
    const resp = await apiService.post(this.baseUrl, payload);
    return resp.data;
  }

  async sendRfqs(transportId: number) {
    const resp = await apiService.post(`${this.baseUrl}/${transportId}/send-rfq`, {});
    return resp.data;
  }
}

export const transportService = new TransportService();
export default transportService;
